import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import "hammerjs";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { hmrBootstrap } from "./hmr";
import * as Sentry from "@sentry/angular-ivy";

Sentry.init({
    dsn: "https://9cf86313a83b42f6b6e021b142a2a452@o537347.ingest.sentry.io/4505075211829248",
    integrations: [
        new Sentry.BrowserTracing({
            routingInstrumentation: Sentry.routingInstrumentation
        }),
        new Sentry.Replay()
    ],
    release: environment.version,
    tracesSampleRate: environment.production || environment.staging ? 0.5 : 1.0,
    replaysSessionSampleRate: environment.production || environment.staging ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0
});


if (environment.production) {
    enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
    // @ts-ignore
    if (module.hot) {
        hmrBootstrap(module, bootstrap);
    } else {
        console.error("HMR is not enabled for webpack-dev-server!");
        console.log("Are you using the --hmr flag for ng serve?");
    }
} else {
    bootstrap().catch(err => console.log(err));
}
